export default {
  root: 'relative flex justify-between m-0 p-0 list-none overflow-x-auto'
}
